module.exports = __webpack_public_path__ + "symbols.svg?e89b7de46772f172c57b1fe49529d924";